import { render, staticRenderFns } from "./TradeStatus.vue?vue&type=template&id=c0446ec2&scoped=true&%3Astatus=status&"
import script from "./TradeStatus.vue?vue&type=script&lang=js&"
export * from "./TradeStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0446ec2",
  null
  
)

export default component.exports